var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTodo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 65,
    x2: 64.937,
    y1: 28,
    y2: 6.8879,
    gradientTransform: "translate(5.1786 919.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4c4c4c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7c7c7",
    offset: 0.15076
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff4f4",
    offset: 0.3422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cacaca",
    offset: 0.65938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#798093",
    offset: 0.85146
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aeaeaf",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 58,
    x2: 58,
    y1: 6,
    gradientTransform: "translate(7.1429 926.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2a2a2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0d0d0",
    offset: 0.14286
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.28571
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#acacc0",
    offset: 0.57143
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 32.928,
    cy: 30.877,
    r: 45,
    gradientTransform: "matrix(.4324 1.6088 -.85133 .22881 50.442 900.19)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9d9d9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 36.828,
    cy: 13.668,
    r: 55.5,
    gradientTransform: "matrix(.91359 1.3041 -.81375 .57007 23.918 910.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9d1c00",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9700",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 5,
    x2: 5,
    y1: 39,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8d8d97",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 42.727,
    x2: 38.03,
    y1: 1036.4,
    y2: 1010.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#936c06",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d89e18",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff8e8",
    offset: 0.82954
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccc",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 28.642,
    x2: 28.503,
    y1: 29.152,
    y2: -1.9099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4b18e",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa500",
    offset: 0.27715
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd27f",
    offset: 0.58242
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe8bf",
    offset: 0.85937
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8c8cf",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 190.76,
    x2: 190.76,
    y1: 29.657,
    y2: -0.64721,
    gradientTransform: "matrix(-.18739 -.27997 -.36579 .24483 -28.223 1004.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727272",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0c0c3",
    offset: 0.43993
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9f9ff",
    offset: 0.63828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.7671
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0a0ac",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 238.36,
    cy: 7.8048,
    r: 15.09,
    gradientTransform: "matrix(.14896 .55942 .61007 -.30209 -110.03 812.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8d14",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f19b42",
    stopOpacity: 0.74902,
    offset: 0.46712
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8f1e",
    stopOpacity: 0.49804,
    offset: 0.79333
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ea6e06",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -924.36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.155 936.27c-4.7537 0-9.5074 4.7537-9.5074 9.5074v90.32c0 4.7537 4.7537 9.5074 9.5074 9.5074h76.059c4.7537 0 10.458-4.7537 10.458-9.5074l-0.95074-90.32c0-4.7537-4.7537-9.5074-9.5074-9.5074z",
    fill: "url(#q)",
    stroke: "#000",
    strokeWidth: 0.95074
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.932 946.26 0.06522 92.813 78.552-0.3148 0.22098-92.669z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.95074 0 0 .95074 4.0658 47.456)",
    stroke: "#000",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.536 932.51v15h49v-15z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.143 932.33-5-6h35l-5 6z",
    fill: "url(#o)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.82286 0 0 .95074 12.501 51.078)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m30.357 38 49.13 0.1046",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m90 33v10h10v-10z",
    fill: "none",
    stroke: "#787878",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m93 34-2 2 4 6 13-13-13 10z",
    fill: "#7b82f9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.82286 0 0 .95074 12.207 70.093)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m30.357 38 49.13 0.1046",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m90 33v10h10v-10z",
    fill: "none",
    stroke: "#787878",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m93 34-2 2 4 6 13-13-13 10z",
    fill: "#7b82f9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.82286 0 0 .95074 12.923 89.009)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m30.357 38 49.13 0.1046",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m90 33v10h10v-10z",
    fill: "none",
    stroke: "#787878",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m93 34-2 2 4 6 13-13-13 10z",
    fill: "#7b82f9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.82286 0 0 .95074 12.207 108.12)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m30.357 38 49.13 0.1046",
    fill: "none",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m90 33v10h10v-10z",
    fill: "none",
    stroke: "#787878",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 924.36)",
    d: "m93 34-2 2 4 6 13-13-13 10z",
    fill: "#7b82f9"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.903 -.13952 .13952 .903 -52.913 90.502)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.18739 -.27997 -.36579 .24483 333.31 762.26)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-140 -20)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 988.36)",
    d: "m-10 34 25-5v10z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 1027.4 40 10v-30c-8.3729 1.9161-22.205 5.3918-40 10z",
    fill: "url(#k)"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 988.36)",
    d: "m-85 29h250v-30h-250z",
    fill: "url(#l)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-58.777 957.8-9.3695-13.999-10.974 7.3449 9.3695 13.999z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-78.729 950.88s-4.0838-5.552-2.9482-6.2307c1.9544-2.846 5.7959-4.7431 8.4394-5.6486 1.7581 0.11896 4.6361 5.1009 4.6361 5.1009z",
    fill: "url(#r)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodo2);
export default __webpack_public_path__ + "static/media/todo2.4b6ee63c979df44342f250c7c17e125b.svg";
export { ForwardRef as ReactComponent };